import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-bold font-heading text-background-50 cursor-pointer">
              韩漫画
            </Link>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              最受欢迎的韩国漫画免费阅读平台，支持下拉式观看，更新及时内容全面，让您轻松追更韩漫。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">首页</Link>
              <Link to="/category/langman" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">漫画分类</Link>
              <Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/langman" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">浪漫爱情</Link>
              <Link to="/category/qihuan" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">奇幻冒险</Link>
              <Link to="/category/dongzuo" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">动作热血</Link>
              <Link to="/category/xuanyi" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">悬疑推理</Link>
              <Link to="/category/bl" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">BL</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <p className="text-sm text-background-300 leading-relaxed">
              如有任何问题或建议，欢迎通过关于我们页面的联系表单与我们取得联系。我们会在第一时间回复您。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 韩漫画 - 韩国漫画免费阅读平台。本站所有内容仅供学习交流。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}